import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter);

var router = new VueRouter({
	routes: [
		{
			path: '/',
			redirect: '/index'
		},
		{
			path: "/introduce",
			name: "Introduce",
			component: () => import('../views/introduce/index.vue')
		}, {
			path: "/index",
			name: "Index",
			component: () => import('../views/index/index.vue'),
			meta:{
        title: '康萍'
      }
		}, {
			path: "/mine",
			name: "Mine",
			component: () => import('../views/mine/index.vue'),
			meta:{
        title: '我的'
      }
		}, {
			path: "/login",
			name: "Login",
			component: () => import('../views/mine/login/index.vue'),
			meta:{
        title: '康萍'
      }
		}, {
			path: "/user-info",
			name: "UserInfo",
			component: () => import('../views/mine/info/index.vue')
		}, {
			path: "/rich-text",
			name: "RichText",
			component: () => import('../views/mine/rich-text/index.vue')
		}, {
			path: "/free-report",
			name: "FreeRecord",
			component: () => import('../views/mine/free-report/index.vue')
		}, {
			path: "/share-record",
			name: "ShareRecord",
			component: () => import('../views/mine/share-record/index.vue')
		}, {
			path: "/student",
			name: "Student",
			component: () => import('../views/mine/student/index.vue')
		}, {
			path: "/testing-record",
			name: "TestingRecord",
			component: () => import('../views/mine/testing-record/index.vue'),
			meta:{
        title: '查看报告'
      }
		}, {
			path: "/vip-card",
			name: "VipCard",
			component: () => import('../views/mine/vip-card/index.vue'),
			meta:{
        title: '会员卡'
      }
		}, {
			path: "/vip-card-record",
			name: "VipCardRecord",
			component: () => import('../views/mine/vip-card-record/index.vue'),
			meta:{
        title: '我的会员卡'
      }
		}, {
			path: "/testing-info",
			name: "TestingInfo",
			component: () => import('../views/index/testing/info/index.vue')
		}, {
			path: "/testing-main",
			name: "TestingMain",
			component: () => import('../views/index/testing/main/index.vue')
		}, {
			path: "/show-report",
			name: "ShowReport",
			component: () => import('../views/index/report/index.vue'),
			meta:{
        title: '查看报告'
      }
		}, {
			path: "/pay",
			name: "Pay",
			component: () => import('../views/index/testing/pay/index.vue')
		}, {
			path: "/welcome5",
			name: "Welcome5",
			component: () => import('../views/index/welcome/index5.vue')
		}, {
			path: "/welcome6",
			name: "Welcome6",
			component: () => import('../views/index/welcome/index6.vue')
		}
	]
});
// router.beforeEach((to, from, next) => {
//   if (to.name == "TestingRecord" || to.name == "ShowReport") {
// 		document.title = '查看报告'
// 		alert(1)
// 	} else {
// 		document.title = '康萍'
// 	}
// });
export default router